module.exports = __webpack_public_path__ + "media/images/Hitonobu-76be250d9c5b5e927e9bc1469c630c68.png";